// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.progressbar[data-v-c55e1cb4] {\r\n  position: fixed;\r\n  z-index: 9001;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #ffffffc7;\n}\r\n", ""]);
// Exports
module.exports = exports;
